import ReactDOM from 'react-dom';
import React from 'react';
import Player from './ui/player';
import store from './data/store';
import { Provider } from 'react-redux';

const init = () => {

    const $placeholder = document.getElementById('iq-player-ph') as HTMLElement;
    if(!$placeholder) return;

    ReactDOM.render(
        <Provider store={store}>
            <Player />
        </Provider>,
        $placeholder
    );
};

document.addEventListener('DOMContentLoaded', () => {
    init();
});

export {}